const TIME_ZONES = {
  'WIT +0900': {
    fullTimeZoneName: 'Eastern Indonesian Time',
    shownCities: [],
    hiddenCities: '',
  },
  'HKT +0800': {
    fullTimeZoneName: 'Hong Kong Time',
    shownCities: [],
    hiddenCities: '',
  },
  'PST +0800': {
    fullTimeZoneName: 'Pacific Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'PKT +0500': {
    fullTimeZoneName: 'Pakistan Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'IST +0530': {
    fullTimeZoneName: 'Indian Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'IST +0100': {
    fullTimeZoneName: 'Irish Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'CDT -0500': {
    fullTimeZoneName: 'Central Daylight Time',
    shownCities: [
      'Bismarck', 'Pierre', 'Minneapolis', 'Milwaukee', 'Lincoln', 'Des Moines', 'Chicago', 'Topeka', 'Kansas City', 'Oklahoma City', 'Little Rock',
      'Memphis', 'Dallas', 'Houston', 'Jackson', 'Montogomery', 'New Orleans', 'Pensacola',
    ],
    hiddenCities: 'Watford City, Williston, Crosby, Portal, New Town, Beulah, Mandan, Bismrck, Fort Yates, McClusky, Oakes, Fargo, Grand, FOrks, Grafton, Ellendale, Cavalier, Mobridge, Selby, Gettysburg, Pierre, Fort Pierre, Murdo, Mission, Winner, Ipswich, Sisseon, Milbank, Brodkings, Madison, Dell Rapids, Sioux Falls, Lake Andes, Yankton, Canton, Vermillion, Thedford, North Platte, McCook, Ainsworth, Burwell, Ansley, Alma, Grand Island, Kearney, Neligh, Hartington, Wayne, West Point, Blair, Fremont, Omaha, Bellevue, Lincoln, Nebraska City, Fairbury, Beatrice, Falls City, Garden City, St Francis, Colby, Oakley, Hugoton, Dodge City, WaKeeney, Salina, Leavenworth, Kansas City, Lawrence, Topeka, Overland Park, Wichita, Arkansas City, Oklahoma City, Boise City, Guymon, Lawton, Enid, Edmond, Moore, Norman, Madill, Shawnee, Stillwater, Ponca City, Bartlesville, Tulsa, Broken Arrow, Muskogee, Amarillo, Lubbock, Wichita Falls, Sherman, McKinney, Texarkana, Denton, Plano, Irving, Garland, Dallas, Fort Worth, Arlington, San Angelo, Waco, Longview, Nacogdoches, Killeen, Huntsville, Beaumont, Georgetown, Cedar Park, Austin, Houston, Pasadena, Baytown, Port Arthur, San Antonio, Del Rio, Van Horn, Alpine, Marta, Presidio, Pecos, Corpus Christi, Kingsville, Laredo, McAllen, Brownsville, Moorhead, Duluth, St Cloud, Ortonville, St Paul, Coon Rapids, Brooklyn Park, Minneapolis, Eden Prairie, Burnsville, Lakeville, Mankato, Rochester, Winona, Superior, Tomahawk, Eau Claire, Marinette, Sturegeon Bay, Green Bay, La Crosse, Madison, Milwaukee, Kenosha, Beloit, Platteville, Mason City, Sioux City, Fort Dodge, Cedar Falls, Waterloo, Dubuque, Marshaltown, Cedar Rapids, Marion, Clinton, iowa City, Davenport, Bettendorf, Ankeny, Urbandale, West Des Moines, Des Moines, Council Bluffs, Knoxville, Chariton, Centerville, Burnlington, Fort Madison, Keokuk, Rockford, Chicago, Naperville, Peoria, Quincy, Springfield, East St Louis, Harrisburg, St Joseph, Edina, Brookfield, Chillicothe, Gladstone, Liberty, Independence, Raytown, Lees Summit, Columbia, St Charles, Jefferson City, St Louis, Oakville, Springfield, Joplin, Cape Girardeau, Poplar Bluff, Dexter, Sikeston, Malden, Branson, Gainseville, Southaven, Corinth,Tupelo, Columbus, Greenville, Meridian, Jackson, Vicksburg, Waynesboro, Hattiesburg, Gulfport, Biloxi, Pascagoula, Rogers, Jonesboro, Springdale, Fayetteville, Huntsville, Batesville, Conway, Jacksonville, West Memphis, Osceola, North Little Rock, Little Rock, Pine Bluff, Arkadelphia, Warren, Shreveport, Bossier City, Monroe, Winnsboro, Tallulah, Mansfield, Alexandria, Ferriday, Lake Charles, Lafayette, Baton Rouge, Slidello, New Orleans, Chalmette, Houma, Huntsville, Decatur, Gadsden Birmingham, Bessemer, Hoover, Tuscaloosa, Homewood, Fairfield, Auburn, Montgomery, Phenix City, Thomasville, Dothan, Mobile, Chikasaw, Prichard, Bay Minette, Daphne, Ironwood, Crystal Falls, Menominee, Gary, Portage, Valparaiso, Princeton, Evansville, Owensboro, Leitchfield, Glasgow, Scottsville, Bowling Green, Henderson, Madisonville, Hopkinsville, Paducan, Princeton, Livingston, Cookeville, McMinnville, Tullahoma, Memphis, Jackson, Germantown, Union City, Savannah, Clarksville, Nashville, Columbia, Franklin, Smyrna, Murfeesboro, Hendersonville, Lebanon, Pensacola, Marianna, Panama City',

  },
  'CDT -0400': {
    fullTimeZoneName: 'Cuba Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'JST +0900': {
    fullTimeZoneName: 'Japan Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'GMT +0000': {
    fullTimeZoneName: 'Greenwich Mean Time',
    shownCities: [],
    hiddenCities: '',
  },
  'EAT +0300': {
    fullTimeZoneName: 'Eastern Africa Time',
    shownCities: [],
    hiddenCities: '',
  },
  'CET +0100': {
    fullTimeZoneName: 'Central European Time',
    shownCities: [],
    hiddenCities: ''
  },
  'WAT +0100': {
    fullTimeZoneName: 'West Africa Time',
    shownCities: [],
    hiddenCities: '',
  },
  'CAT +0200': {
    fullTimeZoneName: 'Central Africa Time',
    shownCities: [],
    hiddenCities: '',
  },
  'EET +0200': {
    fullTimeZoneName: 'Eastern European Time',
    shownCities: [],
    hiddenCities: '',
  },
  'CEST +0200': {
    fullTimeZoneName: 'Central European Summer Time',
    shownCities: [],
    hiddenCities: '',
  },
  'SAST +0200': {
    fullTimeZoneName: 'South Africa Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'HDT -0900': {
    fullTimeZoneName: 'Hawaii–Aleutian Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'AKDT -0800': {
    fullTimeZoneName: 'Alaska Daylight Time',
    shownCities: [
      'Nome', 'Barrow', 'Anchorage', 'Unalaska', 'Juneau',
    ],
    hiddenCities: 'Nome, Barrow, Anchorage, Unalaska, Juneau',
  },
  'AST -0400': {
    fullTimeZoneName: 'Atlantic Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'EST -0500': {
    fullTimeZoneName: 'Eastern Standard Time',
    shownCities: [
      'Detroit', 'Indianapolis', 'Columbus', 'Lousville', 'Charleston', 'Virginia Beach', 'Raleigh', 'Columbia', 'Atlanta', 'Miami', 'Montepelier', 'Portland', 'Boston', 'Hartford',
      'Manchester', 'Buffalo', 'New York', 'Trenton', 'Pittsburgh', 'Annapolis', 'Washington DC',
    ],
    hiddenCities: 'Ontonagon, Ishpeming, Gladstone, Escanaba, Manistique, Marquette, Munising, Newberry, Mount Pleasant, Midland, Muskegon, BayCity, Saginaw, Flint, Grand Rapinds, Lansing, Burton, Port Huron, Sterling Heights, Troy, Detroit, Taylor, Ann Arbor, Jackson, Kalamazoo, Portage, Battle Creek, Coldwater, West Lafayette, Terre Haute, Linton, Shoals, Jasper, Vincennes, South Bend, Elkhart, Goshen, Fort Wayne, Marion, Kokomo, Muncie, Anderson, Noblesville, Carmel, Fishers, Lawrence, Indianapolis, Richmond, Greenwood, Bloomington, Columbus, New Albany, Jeffersonville, Elizabethtown, Campbellsville, Somerset, Louisville, Pleasure Ridge Park, Lebanin, Mount Vernon, Lexington, Covington, Frankfort, Morehead, Ashland, Paintsville, Middlesboro, Harlan, Jenkins, Oneida, Chattanooga, Oak Ridge, Knoxville, Cleveland, Gatlinburg, Kingsport, Johnson City, Tallahassee, Jacksonville, Gainesville, Ocala, Orlando, Palm Coast, Daytona Beach, Ormond Beach, Tampa, Clearwater, Largo, St Petersburg, Sarasota, Bradenton, Palm Bay, Titusville, Fort Pierce, West Palm Beach, Coral Springs, Fort lauderdale, Hollywood, Miami, Hialeah, Miami Beach, Kendall, Homestead, Cape Coral, Fort Mayers, Port Charlotte, Avon Park, Watertown, Utica, Rome, Saratoga Springs, Albany, Syracuse, Auburn, Irondequoit, Rochester, Niagara Falls, Cheektowaga, Buffalo, North Tonawanda, Jamestown, Corning, Elmira, Dansville, Ithaca, Cortland, Binghamton, Schenectady, Poughkeepsie, Middletown, Newburgh, White Plains, Yonkers, New York, Hartford, Waterbury, New Haven, Bridgeport, New London, Putnam, Manchester, Stamford, Norwalk, Greenwich, Milford, Darbury, Woonsocket, Providence, West Warwick, Newport, Pittsfield, Northampton, Springfield, Worcester, Fitchburg, Boston, Burlington, Montpelier, Woodstock, Brattleboro, Bennington, Bellows Falls, Concord, Woodsville, Conway, Dover, Rochester, Nashua, Portsmouth, Augusta, Van Burren, Bangor, Portland, Bar Harbor, Biddeford, Kittery, Dalton, Athens, Atlanta, Macon, Columbus, Savannah, Warner Robins, Valdosta, Murphy, Asheville, Winston-Salem, Greensboro, High Point, Charlotte, Durham, Raleigh, Rocky Mount, Wilson, Goldsboro, Favetteville, Wilmington, Morehead City, Nags Head, Greenville, Anderson, Spartanburg, Rock Hill, Columbia, Aiken, Mt Pleasant, Summerville, Walterboro, Charleston, North Charleston, Hiton Head Island, Arlington, Alexandria, Richmond, Hampton, Portsmouth, Newport News, Virginia Beach, Chesapeake, Abingdon, Lynchburg, Weirton, Wheeling, Morgantown, Martinsburg, Charleston, Huntington, Bluefield, Columbus, Cincinnati, Daytin, Toledo, Bowling Green, Marion, Lima, Akron, Barberton, Cleveland, Youngstown, Massillon, Washington DC, Baltimore, Frostburg, Cumberland, Annapolis, Lexington Park, Pocomoke City, Dundalk, Silver Spring, Rockville, Gaithersburg, Dover, Pittsburgs, Philadelphia, Harrisburg, Allentown, Scranton, Jersey City, Trenton, Atlantic City',
  },
  'CST -0600': {
    fullTimeZoneName: 'Central Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'MDT -0600': {
    fullTimeZoneName: 'Mountain Daylight Time',
    shownCities: [
      'Helena', 'Boise Rapid City', 'Cheyenne', 'Salt Lake City', 'Denver', 'Santa Fe', 'El Paso',
    ],
    hiddenCities: 'Helena, Great Falls, Missoula, Butte, Bozeman, Billings, Miles City, Wolf Point, Belfield, Dickinson, Mott, Carson, Hettinger, Beach, Bowman, Ontario, Vale, Jordan Valley, Salmon, New Meadows, Mc Call, Cascade, Idaho City, Sun Valley Caldwell, Meridian, Nampa, Boise, Ketchum, Idaho Falls, Pocatello, Twin Falls, Malad City, Preston, Sheridan, Buffalo, Moorcroft, Big Piney, Casper, Wheatland, Medicine Bow, Green River, Saratoga, Laramie, Cheyenne, Lemmon, Bison, Dupree, Deadwood, Rapid City, Custer, Martin, Crawford, Rushville, Kimball, Sidney, Ogallala, Imperial, Benkelman, Logan, Salt Lake City, West Valley City, Provo, Delta, Monticello, Panguitch, Cedar City, Fort Collins, Meeker, Loveland, Greeley, Wray, Denver, Aurora, Colorado Springs, Grand Junction, Pagosa Springs, Pueblo, Gunnison, Antonito, Trinidad, Goodland, Sharon Springs, Tribune, Syracuse, Tuba City, Kayenta, Chinle, Window Rock, Winslow, Shiprock, Farmington, Aztec, Tierra Amarilla, Taos, Clayton, Los Alamos, Santa Fe, Mosquero, Rio Rancho, Albuquerque, Clovis, Roswell, Las Cruces, Alamogordo, Carlsbad, Hobbs, El Paso',
  },
  'MST -0700': {
    fullTimeZoneName: 'Mountain Standard Time',
    shownCities: [
      'Phoenix',
    ],
    hiddenCities: 'Colorado City, Grand Canyon, Polacca, Peach Springs, Williams, Flagstaff, Bullhead City, Lake Havasu Cisty, Prescott, Phoenix, Tempe, Scottsdale, Glendale, Mesa, Chandler, Oro Valley, Tucson, Sierra Vista, Yuma, Douglas',
  },
  'EDT -0400': {
    fullTimeZoneName: 'Eastern Daylight Time',
    shownCities: [
      'Detroit', 'Indianapolis', 'Columbus', 'Lousville', 'Charleston', 'Virginia Beach', 'Raleigh', 'Columbia', 'Atlanta', 'Miami', 'Montepelier', 'Portland', 'Boston', 'Hartford',
      'Manchester', 'Buffalo', 'New York', 'Trenton', 'Pittsburgh', 'Annapolis', 'Washington DC',
    ],
    hiddenCities: 'Ontonagon, Ishpeming, Gladstone, Escanaba, Manistique, Marquette, Munising, Newberry, Mount Pleasant, Midland, Muskegon, BayCity, Saginaw, Flint, Grand Rapinds, Lansing, Burton, Port Huron, Sterling Heights, Troy, Detroit, Taylor, Ann Arbor, Jackson, Kalamazoo, Portage, Battle Creek, Coldwater, West Lafayette, Terre Haute, Linton, Shoals, Jasper, Vincennes, South Bend, Elkhart, Goshen, Fort Wayne, Marion, Kokomo, Muncie, Anderson, Noblesville, Carmel, Fishers, Lawrence, Indianapolis, Richmond, Greenwood, Bloomington, Columbus, New Albany, Jeffersonville, Elizabethtown, Campbellsville, Somerset, Louisville, Pleasure Ridge Park, Lebanin, Mount Vernon, Lexington, Covington, Frankfort, Morehead, Ashland, Paintsville, Middlesboro, Harlan, Jenkins, Oneida, Chattanooga, Oak Ridge, Knoxville, Cleveland, Gatlinburg, Kingsport, Johnson City, Tallahassee, Jacksonville, Gainesville, Ocala, Orlando, Palm Coast, Daytona Beach, Ormond Beach, Tampa, Clearwater, Largo, St Petersburg, Sarasota, Bradenton, Palm Bay, Titusville, Fort Pierce, West Palm Beach, Coral Springs, Fort lauderdale, Hollywood, Miami, Hialeah, Miami Beach, Kendall, Homestead, Cape Coral, Fort Mayers, Port Charlotte, Avon Park, Watertown, Utica, Rome, Saratoga Springs, Albany, Syracuse, Auburn, Irondequoit, Rochester, Niagara Falls, Cheektowaga, Buffalo, North Tonawanda, Jamestown, Corning, Elmira, Dansville, Ithaca, Cortland, Binghamton, Schenectady, Poughkeepsie, Middletown, Newburgh, White Plains, Yonkers, New York, Hartford, Waterbury, New Haven, Bridgeport, New London, Putnam, Manchester, Stamford, Norwalk, Greenwich, Milford, Darbury, Woonsocket, Providence, West Warwick, Newport, Pittsfield, Northampton, Springfield, Worcester, Fitchburg, Boston, Burlington, Montpelier, Woodstock, Brattleboro, Bennington, Bellows Falls, Concord, Woodsville, Conway, Dover, Rochester, Nashua, Portsmouth, Augusta, Van Burren, Bangor, Portland, Bar Harbor, Biddeford, Kittery, Dalton, Athens, Atlanta, Macon, Columbus, Savannah, Warner Robins, Valdosta, Murphy, Asheville, Winston-Salem, Greensboro, High Point, Charlotte, Durham, Raleigh, Rocky Mount, Wilson, Goldsboro, Favetteville, Wilmington, Morehead City, Nags Head, Greenville, Anderson, Spartanburg, Rock Hill, Columbia, Aiken, Mt Pleasant, Summerville, Walterboro, Charleston, North Charleston, Hiton Head Island, Arlington, Alexandria, Richmond, Hampton, Portsmouth, Newport News, Virginia Beach, Chesapeake, Abingdon, Lynchburg, Weirton, Wheeling, Morgantown, Martinsburg, Charleston, Huntington, Bluefield, Columbus, Cincinnati, Daytin, Toledo, Bowling Green, Marion, Lima, Akron, Barberton, Cleveland, Youngstown, Massillon, Washington DC, Baltimore, Frostburg, Cumberland, Annapolis, Lexington Park, Pocomoke City, Dundalk, Silver Spring, Rockville, Gaithersburg, Dover, Pittsburgs, Philadelphia, Harrisburg, Allentown, Scranton, Jersey City, Trenton, Atlantic City',
  },
  'PDT -0700': {
    fullTimeZoneName: 'Pacific Daylight Time',
    shownCities: [
      'Olympia', 'Seattle', 'Portland', 'Reno', 'San Francisco', 'Las Vegas', 'Los Angeles',
    ],
    hiddenCities: 'Olympia, Seatle, Tacoma, Bellevue, Vancouver, Yakima, Wenatchee, Spokane, Richland, Pasci, Kennewick, Bonners Ferry, Coeur d’Alene, Lewiston, Orofino, Grangeville, Portland, Salem, Eugene, Springfield, Medford, Bend, Redmond, Burns, Baker City, Eureka, Redding, Chico, Paradise, Yuba City, Sacramento, Santa Rosa, Vallejo, Oakland, San Francisco, Napa, Modesto, Stockton, Fresno, Salinas, San Jose, Fremont, Barkeley, Daly City, Sunnyvale, Bakersfield, Santa Clarita, Oxnard, Ventura, Los Angeles, Long Beach, Santa Ana, Anaheim, Riversdale, Pasadena, Simi Valley, Lancaster, Glendale, Oceanside, San Diego, Chula Vista, Escondido, Reno, Sparks, Carson City, Las Vegas, Henderson',
  },
  'ADT -0300': {
    fullTimeZoneName: 'Atlantic Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'NDT -0230': {
    fullTimeZoneName: 'Newfoundland Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'AEST +1000': {
    fullTimeZoneName: 'Australian Eastern Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'NZST +1200': {
    fullTimeZoneName: 'New Zealand Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'EEST +0300': {
    fullTimeZoneName: 'Eastern European Summer Time',
    shownCities: [],
    hiddenCities: '',
  },
  'CST +0800': {
    fullTimeZoneName: 'China Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'WIB +0700': {
    fullTimeZoneName: 'Western Indonesian Time',
    shownCities: [],
    hiddenCities: '',
  },
  'IDT +0300': {
    fullTimeZoneName: 'Israeli Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'WITA +0800': {
    fullTimeZoneName: 'Central Indonesian Time',
    shownCities: [],
    hiddenCities: '',
  },
  'KST +0900': {
    fullTimeZoneName: 'Korea Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'WEST +0100': {
    fullTimeZoneName: 'Western European Summer Time',
    shownCities: [],
    hiddenCities: '',
  },
  'ACST +0930': {
    fullTimeZoneName: 'Australian Central Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'AWST +0800': {
    fullTimeZoneName: 'Australian Western Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'BST +0100': {
    fullTimeZoneName: 'British Summer Time',
    shownCities: [],
    hiddenCities: '',
  },
  'MSK +0300': {
    fullTimeZoneName: 'Moscow Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'ChST +1000': {
    fullTimeZoneName: 'Chamorro Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'HST -1000': {
    fullTimeZoneName: 'Hawaiian Standard Time',
    shownCities: [
      'Honolulu', 'Hilo',
    ],
    hiddenCities: 'Honolulu, Hilo',
  },
  'SST -1100': {
    fullTimeZoneName: 'Samoa Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'AKST -0900': {
    fullTimeZoneName: 'Alaska Standart Time',
    shownCities: [
      'Nome', 'Barrow', 'Anchorage', 'Unalaska', 'Juneau',
    ],
    hiddenCities: 'Nome, Barrow, Anchorage, Unalaska, Juneau',
  },
  'CST -0500': {
    fullTimeZoneName: 'Central Standart Time',
    shownCities: [],
    hiddenCities: '',
  },
  'PST -0800': {
    fullTimeZoneName: 'Pacific Standart Time',
    shownCities: [
      'Olympia', 'Seattle', 'Portland', 'Reno', 'San Francisco', 'Las Vegas', 'Los Angeles',
    ],
    hiddenCities: 'Olympia, Seatle, Tacoma, Bellevue, Vancouver, Yakima, Wenatchee, Spokane, Richland, Pasci, Kennewick, Bonners Ferry, Coeur d’Alene, Lewiston, Orofino, Grangeville, Portland, Salem, Eugene, Springfield, Medford, Bend, Redmond, Burns, Baker City, Eureka, Redding, Chico, Paradise, Yuba City, Sacramento, Santa Rosa, Vallejo, Oakland, San Francisco, Napa, Modesto, Stockton, Fresno, Salinas, San Jose, Fremont, Barkeley, Daly City, Sunnyvale, Bakersfield, Santa Clarita, Oxnard, Ventura, Los Angeles, Long Beach, Santa Ana, Anaheim, Riversdale, Pasadena, Simi Valley, Lancaster, Glendale, Oceanside, San Diego, Chula Vista, Escondido, Reno, Sparks, Carson City, Las Vegas, Henderson',
  },
  'NST -0330': {
    fullTimeZoneName: 'Newfoundland Standart Time',
    shownCities: [],
    hiddenCities: '',
  },
  'AEDT +1100': {
    fullTimeZoneName: 'Australian Easter Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'NZDT +1300': {
    fullTimeZoneName: 'New Zealand Daylight Time',
    shownCities: [],
    hiddenCities: '',
  },
  'IST +0200': {
    fullTimeZoneName: 'Israel Standard Time',
    shownCities: [],
    hiddenCities: '',
  },
  'WET +0000': {
    fullTimeZoneName: 'Western European Time',
    shownCities: [],
    hiddenCities: '',
  },
  'ACDT +1030': {
    fullTimeZoneName: 'Australian Central Time Zone',
    shownCities: [],
    hiddenCities: '',
  },
};
export default TIME_ZONES;
